export const GAME_GRID_ITEM_SIZE = {
  xl: 1.5,
  lg: 2.4,
  md: 3,
  sm: 4,
  xs: 6,
};
